import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/api.service';

export interface CouponDto {
  id: string;
  code: string;
  discountType: 'percentage' | 'fixed';
  discountValue: number;
  maxUses?: number;
  currentUses: number;
  expiresAt: string;
  isActive: boolean;
  createdAt: string;
  updatedAt?: string;
  description?: string;
  minPurchaseAmount?: number;
  createdBy?: string;
}

export interface CreateCouponRequest {
  code: string;
  discountType: 'percentage' | 'fixed';
  discountValue: number;
  maxUses?: number;
  expiresAt: string;
  description?: string;
  minPurchaseAmount?: number;
}

export interface UpdateCouponRequest {
  code?: string;
  discountType?: 'percentage' | 'fixed';
  discountValue?: number;
  maxUses?: number;
  expiresAt?: string;
  description?: string;
  isActive?: boolean;
  minPurchaseAmount?: number;
}

export interface CouponUsageResponse {
  id: string;
  code: string;
  maxUses?: number;
  currentUses: number;
  usagePercentage: number;
  recentUsages: CouponUseDto[];
}

export interface CouponUseDto {
  id: string;
  supplierId: string;
  supplierName: string;
  usedAt: string;
  orderAmount: number;
  discountAmount: number;
}

@Injectable({ providedIn: 'root' })
export class CouponService {
  constructor(private api: ApiService) {}

  list(params: { page?: number; pageSize?: number; search?: string; status?: string; discountType?: string } = {}): Observable<any> {
    const p = { page: 1, pageSize: 20, ...params };
    return this.api.get('/admin/coupons', p) as Observable<any>;
  }

  getById(id: string): Observable<any> {
    return this.api.get(`/admin/coupons/${id}`) as Observable<any>;
  }

  create(body: CreateCouponRequest): Observable<CouponDto> {
    return this.api.post('/admin/coupons', body) as Observable<CouponDto>;
  }

  update(id: string, body: UpdateCouponRequest): Observable<CouponDto> {
    return this.api.put(`/admin/coupons/${id}`, body) as Observable<CouponDto>;
  }

  delete(id: string): Observable<any> {
    return this.api.delete(`/admin/coupons/${id}`) as Observable<any>;
  }

  getUsage(id: string): Observable<CouponUsageResponse> {
    return this.api.get(`/admin/coupons/${id}/usage`) as Observable<CouponUsageResponse>;
  }
}
